import colors, { createOverlayColorBase } from './colors';
import { defaultTypography, mapTypographyToCss } from './defaultTypography';
import radius from './radius';
import shadows from './shadows';
import spacings from './spacings';

const defaultTheme = {
  color: colors,
  typography: defaultTypography,
  mappedTypography: mapTypographyToCss(defaultTypography),
  createOverlayColor(
    color: string,
    state: 'hover' | 'focused' | 'active' | 'hoverBorder' | 'ripple',
    variant: 'light' | 'dark' = 'light',
  ) {
    return createOverlayColorBase(color, `${state}${variant === 'dark' ? 'Dark' : ''}`, this.color);
  },
  radius,
  shadows,
  spacings,
};

export type TDefaultTheme = typeof defaultTheme;
export default defaultTheme;
